import { useSubmit } from "@certn/api";
import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import { t } from "i18next";

interface ReactivateDeactivateModalProps {
  isTemplateInActivePackage: boolean;
  isActivatingTemplate: boolean;
  close: () => void;
  templateID: string;
  onSuccess: () => void;
}
export function ReactivateDeactivateModal(
  props: ReactivateDeactivateModalProps
) {
  const {
    isActivatingTemplate,
    templateID,
    isTemplateInActivePackage,
    close,
    onSuccess,
  } = props;
  const url = isActivatingTemplate ? "activate" : "deactivate";

  const { submit: toggleTemplateIsActive } = useSubmit(
    `/api/internal/client-portal/check-arguments-templates/credential-verification/${templateID}/${url}/`,
    {
      onSuccess,
    }
  );

  const getDialogueContent = () => {
    if (isActivatingTemplate) {
      return t(
        "By clicking 'Reactivate', this requirement setting will be added back as an option to order"
      );
    }

    if (isTemplateInActivePackage) {
      return t(
        "This template is used in an active package and therefore cannot be de-activated. Please ensure the template is not part of an active package first and then de-activate the template."
      );
    }

    return t(
      "By clicking 'Deactivate', this Requirement Template will be removed as an option to order. Existing orders will not be affected."
    );
  };

  return (
    <Modal testID="add-tag-modal" isOpen>
      <Dialog>
        <>
          <DialogHeader onClose={close}>
            {isActivatingTemplate
              ? t("Reactivate template")
              : t("Deactivate template")}
          </DialogHeader>
          <DialogContent>{getDialogueContent()}</DialogContent>
          <DialogFooter>
            {isActivatingTemplate ? (
              <PrimaryButton
                testID="reactivate"
                onPress={async () => {
                  await toggleTemplateIsActive();
                  close();
                }}
              >
                {t("Reactivate")}
              </PrimaryButton>
            ) : (
              <DangerButton
                testID="deactivate"
                isDisabled={isTemplateInActivePackage}
                onPress={async () => {
                  await toggleTemplateIsActive();
                  close();
                }}
              >
                {t("Deactivate")}
              </DangerButton>
            )}
            <BasicButton onPress={close} testID="close">
              {t("Close")}
            </BasicButton>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
}
